export const filterObjectToString = (obj) => {
  return Object.entries(obj)
    .map(([key, value]) => value && `${key}|${value}`)
    .join(",");
};
export const filterStringToObject = (str) => {
  if (str) {
    return Object.fromEntries(
      str.split(",").map((pair) => {
        const [key, value] = pair.split("|");
        return [key, value];
      })
    );
  } else {
    return {};
  }
};
